// Configuration centralisée de l'URL de l'API.
//
// En local (http://localhost ou http://127.0.0.1) on tape l'API servie par MAMP
// (qui pointe elle-même vers la base MySQL locale, voir public/api.php).
// Partout ailleurs (prod), on garde l'API de production.
//
// -> Si tu changes le port de MAMP, adapte URL_API_LOCAL ci-dessous.

const isLocalhost =
  typeof window !== 'undefined' &&
  (window.location.hostname === 'localhost' ||
    window.location.hostname === '127.0.0.1');

// MAMP sert Apache/PHP sur le port 8888 par défaut.
const URL_API_LOCAL = 'http://localhost:8888/';
const URL_API_PROD = 'https://www.brandpredictor.ch/';

export const URL_API = isLocalhost ? URL_API_LOCAL : URL_API_PROD;

export default URL_API;
